module.exports = __webpack_public_path__ + "static/media/banesco-vest.3f8d7460.svg";